module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_1000000.ef115d37.png";